import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../../lib/api';
import { DataTable } from '../../components/DataTable';
import { PageHeader } from '../../components/PageHeader';
import { SearchInput } from '../../components/SearchInput';
import { ErrorBanner } from '../../components/ErrorBanner';
import { useScope } from '../../context/ScopeContext';
import { useAuth } from '../../context/AuthContext';
import { CustomerCreateModal } from './components/CustomerCreateModal';

export function CustomersPage() {
  const scope = useScope();
  const { can } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const querySearch = params.get('q') ?? '';
  const [search, setSearch] = useState(querySearch);

  useEffect(() => setSearch(querySearch), [querySearch]);

  const q = useQuery({
    queryKey: ['customers', scope.companyId, scope.branchId, search],
    queryFn: () => api<any>(`/crm/customers?page=1&pageSize=100&companyId=${scope.companyId}${scope.branchId ? `&branchId=${scope.branchId}` : ''}&search=${encodeURIComponent(search)}`),
    enabled: Boolean(scope.companyId),
  });

  return <section>
    <PageHeader
      title="Customers"
      subtitle="Customer master, notes, documents, reminders and ratings"
      actions={can('crm.customer.manage') ? <CustomerCreateModal onCreated={customer => navigate(`/crm/customers/${customer.id}`)} /> : null}
    />
    <div className="toolbar"><SearchInput value={search} onChange={setSearch} /></div>
    <ErrorBanner error={q.error} />
    <div className="card"><DataTable rows={q.data?.items ?? []} columns={[
      { key: 'code', header: 'Code', render: (row: any) => <Link to={`/crm/customers/${row.id}`}>{row.code}</Link> },
      { key: 'name', header: 'Name', render: (row: any) => `${row.firstName} ${row.middleName ?? ''} ${row.lastName ?? ''}`.replace(/\s+/g, ' ').trim() },
      { key: 'phone', header: 'Phone', render: (row: any) => row.phone },
      { key: 'active', header: 'Status', render: (row: any) => row.active ? 'Active' : 'Inactive' },
    ]} /></div>
  </section>;
}
